import Image from 'app/Components/Shared/Image/image';
import React,{ useState, useEffect } from 'react';
import Config from '../../../../../../Config';
import PopUp from '../../../../../Shared/Popup/PopUp';
import { isAddonId } from '../addonEntryPopupHelpers';

const SAFE_SURFING_ADDON_ID = '7804NB';

function formatAddonPrice(price) {
  const numericPrice = parseFloat(price);

  if (Number.isNaN(numericPrice)) {
    return price;
  }

  return Number.isInteger(numericPrice) ? `${numericPrice}` : numericPrice.toFixed(2);
}

export const ServiceAddon = (props) => {
  const {
    serviceAddons,
    gtag4,
    saleType,
    flowType,
    buildUrlAndOpenWindow,
    isEntryPopup,
  } = props;

  if(serviceAddons === undefined || serviceAddons.length === 0) return;

  const [isDisplayPopup, setIsDisplayPopup] = useState(false);

  const addonGroup = serviceAddons[0];
  const serviceAddonsJet = addonGroup.addonsList[0];
  const serviceAddonsCms = addonGroup.cmsData || serviceAddonsJet?.cmsData;
  const isSafeSurfing = isAddonId(addonGroup, SAFE_SURFING_ADDON_ID, serviceAddonsCms);
  const showSafeSurfingPrice = isSafeSurfing && !!serviceAddonsJet?.price;

  useEffect(()=> {
    gtag4({
      event: `${saleType}_Step5_AddonDisplay`,
      step: '5',
      content: serviceAddonsCms.id,
      action: 'AddonDisplay',
      funnel_name: `${saleType}_Exists${flowType}_Customer`
     });
  },[]);

  const handleClosePopup = ()=> {
    setIsDisplayPopup(false);
  };

  const priceDisplay = (descriptionPrice) => {
    let description = '';
    const isDisplayDelete = parseFloat(descriptionPrice.price) < parseFloat(descriptionPrice?.originalPrice);
    const month = ['הראשון', 'השני', 'השלישי', 'הרביעי', 'החמישי', 'השישי', 'השביעי', 'השמיני', 'התשיעי', 'העשירי'];

    // Check for whether a graded price is received
    const objForAmount = descriptionPrice.priceItemList.find((item) => (item.from === 0 || item.to === 0) && item.amount !== 0);
    const objForPrice = descriptionPrice.priceItemList.find((item) => (item.from !== 0));

    if(descriptionPrice.priceItemList.length >= 2 || objForAmount?.amount != null) { //tiered price
      const { amount, price: priceFirst } = objForAmount;
      const { price: priceSec  } = objForPrice;
      const monthName = month[Number(amount)];
      description =`
      <div class='tiered-price'>
        <div class='row-price'>
          <div>חיוב לחודש הראשון  </div>
          <div class='price'> <span>₪</span>${priceFirst} </div>
        </div>
        <div class='row-price'>
          <div>חיוב חודשי החל מהחודש ${monthName} </div>
          <div class='price'> <span>₪</span>${priceSec} </div>
        </div>
      </div>`
    }else if (isDisplayDelete) { // delete price
      description = `
      <div class='delete-price'>
        <div class='text-price'> חיוב לחודש</div>
        <div class='price'> <span>₪</span>${descriptionPrice.price} <span class='price-discount'>במקום
        <del>₪${descriptionPrice?.originalPrice}</del>
        </span>
      </div>`
    } else {  // Normal display for the price
      description =`
        <div class='text-price'>חיוב לחודש</div>
        <div class='price'><span> ₪</span>${serviceAddonsJet.price}`;
    };
    return description;
  };

  return (
    <div className={`addons-service-wrapper${isSafeSurfing ? ' addons-service-wrapper--safe-surfing' : ''}`}>
      {serviceAddonsCms.imageAddon && <Image src={Config.epiBaseUrl + serviceAddonsCms.imageAddon} alt={serviceAddonsCms.name} />}
      {serviceAddonsCms.titleAddonSingle && <h1 dangerouslySetInnerHTML={{ __html: serviceAddonsCms.titleAddonSingle }}></h1>}
      {serviceAddonsCms.descriptionProduct && <h2 dangerouslySetInnerHTML={{ __html: serviceAddonsCms.descriptionProduct }}></h2>}
      {serviceAddonsJet.price && showSafeSurfingPrice &&
        <div className='list-price list-price--safe-surfing'>
          <span className='list-price__amount'>{formatAddonPrice(serviceAddonsJet.price)}</span>
          <span className='list-price__period'>₪ לחודש</span>
        </div>
      }
      {serviceAddonsJet.price && !showSafeSurfingPrice &&
      <div
        className={`list-price ${serviceAddonsJet.priceItemList?.length > 1 ? 'higher-wider' : ''}`}
        dangerouslySetInnerHTML={{ __html: priceDisplay(serviceAddonsJet) }}>
      </div>
      }
      {(!isEntryPopup || isSafeSurfing) && serviceAddonsCms.textLink && (
        <a href='#' onClick={() => setIsDisplayPopup(true)}>{serviceAddonsCms.textLink}</a>
      )}
      <PopUp
        showPopUp={isDisplayPopup}
        onClose={() => setIsDisplayPopup(false) }
        footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}
      >
        <div className='card-popup'>
          {serviceAddonsCms.imagePopUp &&<Image src={Config.epiBaseUrl + serviceAddonsCms.imagePopUp} alt="image" />}
          {serviceAddonsCms.titlePopUp && <h1 dangerouslySetInnerHTML={{ __html: serviceAddonsCms.titlePopUp }}></h1>}
          {serviceAddonsCms.textPopUp &&<div className='text-popup' dangerouslySetInnerHTML={{ __html: serviceAddonsCms.textPopUp }}></div>}
          {serviceAddonsCms.linkRegulations && <a href='#' onClick={(e)=> {e.preventDefault(); buildUrlAndOpenWindow(serviceAddonsCms.linkRegulations)}}>{serviceAddonsCms.textLinkPopUp}</a>}
        </div>
      </PopUp>
    </div>
  )
};
